"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.heading.chat': 'Start talking to your AI assistant',
    'chat.heading.ask': 'Ask your question',
};
